module.exports = __webpack_public_path__ + "static/13-1e7043513cbd29776faa6b1ec8452cc1.jpg";